export const KEY_TO_STORAGE_DEMO_USER = 'demo';
